/**
 * Used when workspace law-firm API fails locally and the Node mock seeds data for one tenant.
 * Must match `lawFirmId` in `server/data/firm-companies.json`.
 */
export const DEFAULT_LOCAL_LAW_FIRM_GUID = '00000000-0000-0000-0000-000000000001';
